<template>
  <v-card style="height: 130px">
    <v-layout mx-3 pt-5 row wrap justify-center>
        <h3>Este pedido expirou em {{expired}}</h3>
    </v-layout>
  </v-card>
</template>

<script>
import moment from 'moment'
export default {
  computed: {
    orderPdvData () {
      return this.$store.getters.orderPdvData;
    },
    expired () {
      return moment(this.orderPdvData.data_expiracao_pedido).format('DD/MM/YYYY [as] HH:mm')
    }
  }
}
</script>

<style scoped>
.container-queue {
  height: 400px;
}
.title-queue {
  font-size: 24px;
  line-height: 28px;
  font-weight: 500;
  letter-spacing: -0.25px;
  text-align: left;
}
.subtitle-queue {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.25px;
  text-align: left;
}
.box-queue {
  height: 64px;
  width: 426px;
  padding: 10px 15px;
  background: #1976d23d;
  border-radius: 12px;
  display: flex;
  justify-content: start;
  align-items: center;
}
.text-queue {
  font-size: 14px;
  line-height: 16px;
  letter-spacing: -0.25px;
  text-align: right;
  font-weight: bold;
  color: #192B46;
}
.number-queue {
  font-size: 24px;
  line-height: 16px;
  letter-spacing: -0.25px;
  text-align: right;
  font-weight: bold;
  color: #192B46;
}
</style>